import PageLayout from "@/components/base/page-layout";
import withErrorBoundary from "@/components/hoc/with-error-boundary";
import Profile from "@/components/profile";

const ProfilePage: React.FC = () => {
  return (
    <PageLayout title="Profile" isForm>
      <Profile />
    </PageLayout>
  );
};

export default withErrorBoundary({ component: "ProfilePage" })(ProfilePage);
